import React, {useEffect} from "react";
import { motion } from "framer-motion";
import MainHeader from "../Components/MainHeader";
import SchemaMarkup from "../Components/SchemaMarkup";
import webPageSchema from "../Schema/WebPageSchema";

const PrivacyPolicy=()=>{
    useEffect(() => {
        document.title =
          "Privacy Policy | Iris Impulse India Pvt. Ltd.";
    
        const metaDesc = document.querySelector("meta[name='description']");
        if (metaDesc) {
          metaDesc.setAttribute(
            "content",
            "Iris Impulse India Pvt. Ltd. is committed to protecting your personal data in mining, processing and export operations. Read our Privacy Policy."
          );
        }
    
         const canonical = document.querySelector("link[rel='canonical']");
      if (canonical) {
        canonical.setAttribute("href", "https://irisimpulse.com/privacy-policy");
      }
    
      const ogTitle = document.querySelector("meta[property='og:title']");
      if (ogTitle) {
        ogTitle.setAttribute(
          "content",
          "Privacy Policy | Iris Impulse India Pvt. Ltd."
        );
      }
    
        const ogDesc = document.querySelector("meta[property='og:description']");
      if (ogDesc) {
        ogDesc.setAttribute(
          "content",
          "Iris Impulse India Pvt. Ltd. is committed to protecting your personal data in mining, processing and export operations. Read our Privacy Policy."
        );
      }
    
      const ogUrl = document.querySelector("meta[property='og:url']");
      if (ogUrl) {
        ogUrl.setAttribute("content", "https://irisimpulse.com/privacy-policy");
      }
    
        const ogImage = document.querySelector("meta[property='og:image']");
      if (ogImage) {
        ogImage.setAttribute(
          "content",
          "https://irisimpulse.com/Images/home.webp"
        );
      }
    
        const twitterTitle = document.querySelector("meta[name='twitter:title']");
      if (twitterTitle) {
        twitterTitle.setAttribute(
          "content",
          "Privacy Policy | Iris Impulse India Pvt. Ltd."
        );
      }
    
        const twitterDesc = document.querySelector(
        "meta[name='twitter:description']"
      );
      if (twitterDesc) {
        twitterDesc.setAttribute(
          "content",
          "Iris Impulse India Pvt. Ltd. is committed to protecting your personal data in mining, processing and export operations. Read our Privacy Policy."
        );
      }
    
        const twitterImage = document.querySelector("meta[name='twitter:image']");
      if (twitterImage) {
        twitterImage.setAttribute(
          "content",
          "https://irisimpulse.com/Images/home.webp"
        );
      }
      }, []);

      const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15
    }
  }
};

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" }
  }
};

const webPageData = webPageSchema({
  url: "https://irisimpulse.com/privacy-policy",
  title: "Privacy Policy | Iris Impulse India Pvt. Ltd.",
  description: "Iris Impulse India Pvt. Ltd. is committed to protecting your personal data in mining, processing and export operations. Read our Privacy Policy.",
  image:"https://irisimpulse.com/Images/home.webp",
});
    return(
        <>
         <SchemaMarkup data={webPageData} />

        <MainHeader />

        <motion.section className="privacy-policy-section container"
        variants={container}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true, margin: "-80px" }}>
            <h1>Privacy Policy</h1>

             <motion.h2 className="section-heading" variants={fadeUp}>1. Introduction</motion.h2>
          <motion.p className="section-text" variants={fadeUp}>
            Iris Impulse India Pvt. Ltd. (“we”, “us”, “our”) is engaged in mining,
            processing, and exporting industrial minerals worldwide. We respect
            your privacy and are committed to safeguarding the information you
            share with us.
          </motion.p>

          {/* Information Collection */}
          <motion.h2 className="section-heading" variants={fadeUp}>2. Information We Collect</motion.h2>
          <motion.p className="section-text" variants={fadeUp}>We may collect information such as:</motion.p>
          <ul>
            <motion.li variants={fadeUp}>Client and supplier details (name, company, contact info)</motion.li>
            <motion.li  variants={fadeUp}>Shipping and customs documentation details</motion.li>
            <motion.li variants={fadeUp}>Website usage data (IP, cookies, forms submitted)</motion.li>
            <motion.li  variants={fadeUp}>Employee and contractor records (for HR & compliance)</motion.li>
          </ul>

          {/* Use of Info */}
          <motion.h2 className="section-heading" variants={fadeUp}>3. How We Use Your Information</motion.h2>
          <ul>
            <motion.li variants={fadeUp}>To process orders, shipments, and export documentation</motion.li>
            <motion.li variants={fadeUp}>To comply with customs, trade, and regulatory laws</motion.li>
            <motion.li variants={fadeUp}>To provide customer service and respond to inquiries</motion.li>
            <motion.li variants={fadeUp}>To improve our operations, services, and security</motion.li>
          </ul>

          {/* Disclosure */}
          <motion.h2 className="section-heading" variants={fadeUp}>4. Sharing & Disclosure</motion.h2>
          <motion.p className="section-text" variants={fadeUp}>
            We do not sell your personal information. We may share data with:
          </motion.p>
          <ul>
            <motion.li variants={fadeUp}>Logistics partners, customs agents, and shipping companies</motion.li >
            <motion.li  variants={fadeUp}>Government authorities where legally required</motion.li >
            <motion.li  variants={fadeUp}>Service providers bound by confidentiality agreements</motion.li >
          </ul>

          {/* Security */}
          <motion.h2 className="section-heading" variants={fadeUp}>5. Security Measures</motion.h2>
          <motion.p className="section-text" variants={fadeUp}>
            We implement industry-standard practices to protect data from
            unauthorized access, misuse, or disclosure, including encryption,
            access control, and audits.
          </motion.p>

          {/* International Transfers */}
          <motion.h2 className="section-heading" variants={fadeUp}>6. International Data Transfers</motion.h2>
          <motion.p className="section-text" variants={fadeUp}>
            As an export-oriented company, data may be transferred internationally.
            We ensure such transfers comply with applicable data protection laws.
          </motion.p>

          {/* Rights */}
          <motion.h2 className="section-heading" variants={fadeUp}>7. Your Rights</motion.h2>
          <motion.p className="section-text" variants={fadeUp}>You have the right to:</motion.p>
          <ul>
            <motion.li variants={fadeUp}>Access and update your personal data</motion.li>
            <motion.li variants={fadeUp}>Request deletion of your data where legally permitted</motion.li>
            <motion.li variants={fadeUp}>Withdraw consent for non-essential uses</motion.li>
            <motion.li variants={fadeUp}>Raise concerns with data protection authorities</motion.li>
          </ul>

          {/* Policy Updates */}
          <motion.h2 className="section-heading" variants={fadeUp}>8. Changes to this Policy</motion.h2>
          <motion.p className="section-text" variants={fadeUp}>
            We may revise this Privacy Policy as required by operational,
            legal, or regulatory changes. Updates will be posted on this page.
          </motion.p>

          {/* Contact */}
          <motion.h2 className="section-heading" variants={fadeUp}>9. Contact Us</motion.h2>
          <motion.p  className="section-text" variants={fadeUp}>
            For questions or concerns, reach us at:
          </motion.p >

          <div >
            <div>
              <motion.address variants={fadeUp}>
                “IRIS HOUSE”, PLOT-39, WARD-7/C, Gurukul Road, Opp P. N. Amershey School, Gandhidham, Kutch, Gujarat, India, 370201
              </motion.address>
            </div>
            <motion.p variants={fadeUp}>
              <a href="mailto:rajan@irisimpulse.com">rajan@irisimpulse.com</a>
            </motion.p >
            <motion.p  variants={fadeUp}>
              <a href="tel:+919638482211">+91 96384 82211</a>
            </motion.p >
          </div>
        </motion.section>
        </>
    )
}
export default PrivacyPolicy;